import React from 'react';
import './Resume.css'; 

const Resume = () => {
  return (
    <section id="resume" className="resume">
      
      
      <a
        href="/Sudhir_Jaiswal_Resume.pdf"
        download="Sudhir_Jaiswal_Resume.pdf"
        className="resume-btn"
      >
        Download Resume
      </a>
    </section>
  );
};

export default Resume;
